define(function(require, exports, module) {
    'use strict';
    var PortletModel = require('modules/portlet/portlet.model');
    var UpdateDetails = require('portlets/update-details/updatedetails.view');
    var userValidationConfig = require('modules/user/user.validation.config');

    module.exports = PortletModel.extend({

        initialize: function() {
            PortletModel.prototype.initialize.apply(this, arguments);

            this.get('config').validation = userValidationConfig;
        },

        getView: function() {
            return new UpdateDetails({model: this});
        }

    });
});